<template>
  <div>
      <b-card header="Auditoría"  header-tag="header" class=" header m-0 h-100">
        <!-- Header -->
        <template #header>
          <i class="mdi mdi-history mr-1" style="font-size: 1.3rem"></i>
          <strong class="mb-0 p-0">{{ $t('audit') }}</strong>
        </template>
        <!-- Content -->
        <b-card-text class="text-left content">
          <b-spinner v-if="isLoading" label="Cargando..." variant="secondary" small class="mb-2" ></b-spinner>
          <div v-if="!isLoading">
            <a-timeline
        class="p-4"
        v-if="movements.items.length"
      >
              <a-timeline-item
                v-for="(m, index) of movements.items"
                :key="index"
              >
                <div class="datos d-flex flex-column mx-2">
                  <span>
                    <b-avatar
                      class="my-1"
                      size="2.2em"
                      :text="emptyUserAvatar(m)"
                      variant="primary"
                      :src="m.avatar"
                    ></b-avatar>
                    <span class="mx-2"><strong>{{`${userFullName(m)}`}}</strong>{{` ${m.activity}`}}</span>
                  </span>
                  <span
                    v-if="m.createdAt"
                    class="font-weight-light my-1"
                  >
                    {{ m.createdAt }}
                  </span>
                  <a @click="showDetails(index)" class="link-primary">{{ m.show ? 'Ocultar detalle' : 'Ver detalle' }}</a>
                  <div v-if="m.show" class="mt-2">
                    <div class="mt-0" v-if="m.createdBy.user.area"><strong>Área:</strong> {{m.createdBy.user.area.name}}</div>
                    <div v-if="m.createdBy.user.subarea"><strong>Subárea:</strong> {{m.createdBy.user.subarea.name}}</div>
                    <hr>
                    <div
                      v-for="(key, index) in m.data.modifiedFields"
                      :key="index"
                      class="mt-2"
                    >
                      <strong>• {{ key.label }}</strong>
                      <div v-if="key.added">
                        <strong>Se agregó: </strong>
                        {{key.added}}
                      </div>
                      <div v-if="key.removed">
                        <strong>Se quitó: </strong>
                        {{key.removed}}
                      </div>
                      <div v-if="!key.added && !key.removed">
                      {{ `${key.previousValue} →  ${key.newValue}` }}
                      </div>
                    </div>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <LmError v-else/>
          </div>
        </b-card-text>
      </b-card>
  </div>
</template>

<script>
import commonsApi from '@/api/commons'
import LmError from '@/components/LmError.vue'
export default {
  data () {
    return {
      toggleLoginHistory: null,
      isLoading: false,
      movements: {
        items: []
      }
    }
  },
  components: {
    LmError
  },
  computed: {
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    async getResponse () {
      try {
        this.isLoading = true

        const historyResponse = await commonsApi.axiosGetWrapper(`/users/audithistory/${this.value.id}`)

        this.movements.items = historyResponse.data || []
        this.movements.items = this.movements.items.map(item => {
          item.show = false
          return item
        })
        this.toggleLoginHistory = !this.toggleLoginHistory
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    emptyUserAvatar (m) {
      if (m.createdBy) {
        return m.createdBy?.user.firstname?.charAt(0) + m.createdBy?.user.lastname?.charAt(0)
      }
      return null
    },
    userFullName (m) {
      const fullname = `${m.createdBy?.user?.firstname || ''} ${m.createdBy?.user?.lastname || ''}`
      return fullname
    },
    showDetails (index) {
      if (!this.movements.items[index].show) {
        this.movements.items[index].show = true
      } else {
        this.movements.items[index].show = false
      }
      this.$forceUpdate()
    }
  },
  created () {
    this.getResponse()
  }
}
</script>

<style lang="sass" scoped>
.content
  max-height: 300px
  margin-bottom: 23px
  overflow: scroll
</style>
